import { UsersSelectorComponent } from "./users-selector.component";

const mod = angular.module("usersSelector", []);
mod.component("usersSelector", UsersSelectorComponent);
export default mod.name;
